import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  CircularProgress,
  InputAdornment,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
  IconButton,
  ImageList,
  ImageListItem,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiButton from "components/VuiButton";
import VuiTypography from "components/VuiTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import VuiPagination from "components/VuiPagination";
import Icon from "@mui/material/Icon";
import { useParams } from "react-router-dom";
import { green, grey } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";

function MaintenanceTracker() {
  const [open, setOpen] = useState(false);

  const handleGridClick = () => {
    if (!open) {
      setOpen(true);
    }
  };
  const { site_id, section_id } = useParams();
  const [sectionName, setSectionName] = useState("");
  const [maintenanceItems, setMaintenanceItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(10);
  const [taskDialogOpen, setTaskDialogOpen] = useState(false);
  const [pictureDialogOpen, setPictureDialogOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [taskCompletions, setTaskCompletions] = useState({});
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [currentPhotos, setCurrentPhotos] = useState([]);
  const [siteName, setSiteName] = useState("");
  const [newTaskItems, setNewTaskItems] = useState([""]);
  const [commentsDialogOpen, setCommentsDialogOpen] = useState(false);
  const [currentComments, setCurrentComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [editingPart, setEditingPart] = useState(null);
  const [editingTaskItem, setEditingTaskItem] = useState(null);
  const [editedTaskItemText, setEditedTaskItemText] = useState("");
  const [newTaskItemText, setNewTaskItemText] = useState("");
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [editingBreakdown, setEditingBreakdown] = useState(null);
  const [editedBreakdownDescription, setEditedBreakdownDescription] = useState("");
  const [editedBreakdownDate, setEditedBreakdownDate] = useState("");
  const [editingComment, setEditingComment] = useState(null);
  const [editedCommentText, setEditedCommentText] = useState("");
  const navigate = useNavigate();

  const handleOpenEditDialog = (item) => {
    setEditingItem({
      ...item,
      interval_type: item.interval_type || "", // Ensure interval_type has a default value
      interval_value: item.interval_value || "", // Ensure interval_value has a default value
    });
    setEditDialogOpen(true);
  };
  const [newItem, setNewItem] = useState({
    task_name: "",
    task_description: "",
    hours_usage: 0,
    maintenance_interval: 0,
    task_items: [],
    section_id: section_id || "",
  });
  const [newParts, setNewParts] = useState([
    {
      part_name: "",
      part_number: "",
      manufacturer: "",
      quantity: 1,
      cost: 0.0,
    },
  ]);
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const [editingField, setEditingField] = useState({ id: null, field: null });
  const [partsDialogOpen, setPartsDialogOpen] = useState(false);
  const [currentParts, setCurrentParts] = useState([]);
  const [newPart, setNewPart] = useState({
    part_name: "",
    part_number: "",
    manufacturer: "",
    quantity: 1,
    cost: 0.0,
  });
  const [breakdownsDialogOpen, setBreakdownsDialogOpen] = useState(false);
  const [newBreakdownDescription, setNewBreakdownDescription] = useState("");
  const [newBreakdownDate, setNewBreakdownDate] = useState("");

  const email = localStorage.getItem("email");
  const userName = localStorage.getItem("name");

  // Add these state variables near the top of the component
  const [stockItems, setStockItems] = useState([]);
  const [stockDialogOpen, setStockDialogOpen] = useState(false);
  const [selectedStockItem, setSelectedStockItem] = useState(null);

  // Function to check and send maintenance notifications
  const checkAndSendMaintenanceNotification = async (task) => {
    try {
      const intervalValue = task.interval_value;
      const intervalType = task.interval_type;

      if (!intervalValue || !intervalType) return; // Skip if no interval set

      // For time-based intervals, calculate based on created_at date
      const createdDate = new Date(task.created_at);
      const now = new Date();
      let daysPassed;

      if (intervalType === "day") {
        daysPassed = (now - createdDate) / (1000 * 60 * 60 * 24);
      } else if (intervalType === "week") {
        daysPassed = (now - createdDate) / (1000 * 60 * 60 * 24 * 7);
      } else if (intervalType === "month") {
        // Approximate month as 30 days
        daysPassed = (now - createdDate) / (1000 * 60 * 60 * 24 * 30);
      }

      const currentUsage = daysPassed;
      const threshold = intervalValue;

      if (currentUsage >= threshold) {
        await fetch(
          `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/SES-API/send-maintenance-notification`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              email: email,
              equipment_name: task.item,
              usage_percentage: Math.round((currentUsage / threshold) * 100),
              task_id: task.id,
              site_id: site_id,
            }),
          }
        );
      }
    } catch (error) {
      console.error("Error sending maintenance notification:", error);
    }
  };
  // Fetch site data
  const fetchSiteData = async () => {
    try {
      // Fetch site name
      const siteResponse = await fetch(
        `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/site/profile?site_id=${site_id}`
      );
      const siteData = await siteResponse.json();
      setSiteName(siteData.name);

      // Fetch section name if section_id exists
      if (section_id) {
        const sectionResponse = await fetch(
          `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/sections/profile?section_id=${section_id}`
        );
        const sectionData = await sectionResponse.json();
        setSectionName(sectionData.section_name);
      }
    } catch (error) {
      console.error("Error fetching site/section data:", error.message);
    } finally {
      setLoading(false);
    }
  };

  // Fetch tasks
  const fetchTasks = async () => {
    setLoading(true);
    try {
      let response;
      if (section_id) {
        // Fetch tasks for a specific section
        response = await fetch(
          `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/sections/tasks?section_id=${section_id}`
        );
      } else {
        // Fetch all tasks for the site
        response = await fetch(
          `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/sites/tasks?site_id=${site_id}`
        );
      }

      if (!response.ok) throw new Error("Failed to fetch tasks");
      const data = await response.json();

      // Fetch breakdowns for each task
      const transformedData = await Promise.all(
        data.map(async (task) => {
          const breakdownResponse = await fetch(
            `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/breakdowns?task_id=${task.task_id}`
          );
          const breakdowns = await breakdownResponse.json();

          return {
            id: task.task_id,
            item: task.task_name,
            items: task.item || [],
            breakdowns,
            photo_count: task.photo_count || 0,
            part_count: task.part_count || 0,
            comment_count: task.comment_count || 0,
            taskitem_count: task.taskitem_count || 0,
            completed_items: task.completed_items || 0,
            interval_type: task.interval_type,
            interval_value: task.interval_value,
            due_date: task.due_date,
            breakdown_description: task.breakdown_description || null,
            breakdown_date: task.breakdown_date || null,
            status: task.status || "pending",
            completed_at: task.completed_at,
          };
        })
      );

      setMaintenanceItems(transformedData);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSiteData();
    fetchTasks();
    fetchStockItems();
  }, [site_id]);

  // Handle field edit
  const handleFieldEdit = (id, field) => {
    setEditingField({ id, field });
  };

  // Handle field update
  const handleFieldUpdate = async (id, field, value) => {
    try {
      const item = maintenanceItems.find((item) => item.id === id);
      const updatedValue = Number(value);

      await fetch(`https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/update`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          task_id: id,
          [field]: updatedValue,
        }),
      });

      // Check if we need to send maintenance notification
      if (field === "hours_usage") {
        await checkAndSendMaintenanceNotification({
          ...item,
          hours_usage: updatedValue,
        });
      }

      await fetchTasks();
    } catch (error) {
      console.error("Error updating task:", error);
    } finally {
      setEditingField({ id: null, field: null });
    }
  };

  // Handle complete task
  const handleCompleteTask = async (taskId, currentStatus) => {
    if (window.confirm("Are you sure you want to change the Completion Status?")) {
      try {
        const newStatus = currentStatus === "completed" ? "pending" : "completed";

        // Find the task in maintenanceItems to get interval details
        const task = maintenanceItems.find((item) => item.id === taskId);

        const response = await fetch(
          "https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/update",
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              task_id: taskId,
              status: newStatus,
              // Only send interval info if we're completing the task
              ...(newStatus === "completed" && task.interval_type && task.interval_value
                ? {
                    interval_type: task.interval_type,
                    interval_value: task.interval_value,
                  }
                : {}),
            }),
          }
        );

        if (!response.ok) throw new Error("Failed to update task status");

        // Update the local state immediately for better UX
        setMaintenanceItems((prevItems) =>
          prevItems.map((item) =>
            item.id === taskId
              ? {
                  ...item,
                  status: newStatus,
                  // Update due_date if we're completing the task and it has an interval
                  ...(newStatus === "completed" && task.interval_type && task.interval_value
                    ? {
                        due_date: calculateNewDueDate(task.interval_type, task.interval_value),
                      }
                    : {}),
                }
              : item
          )
        );
      } catch (error) {
        console.error("Error updating task status:", error);
      }
    }
  };

  // Helper function to calculate new due date
  const calculateNewDueDate = (intervalType, intervalValue) => {
    const now = new Date();
    switch (intervalType) {
      case "day":
        return new Date(now.getTime() + intervalValue * 24 * 60 * 60 * 1000).toISOString();
      case "week":
        return new Date(now.getTime() + intervalValue * 7 * 24 * 60 * 60 * 1000).toISOString();
      case "month":
        // Approximate month as 30 days
        return new Date(now.getTime() + intervalValue * 30 * 24 * 60 * 60 * 1000).toISOString();
      default:
        return null;
    }
  };

  // Handle delete task
  const handleDeleteTask = async (taskId) => {
    if (window.confirm("Are you sure you want to delete this task?")) {
      try {
        await fetch(
          `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/delete?task_id=${taskId}`,
          {
            method: "DELETE",
          }
        );
        fetchTasks();
      } catch (error) {
        console.error("Error deleting task:", error);
      }
    }
  };

  // Handle add task
  const handleAddItem = async () => {
    try {
      const filteredTaskItems = newTaskItems.filter((item) => item.trim() !== "");
      const filteredParts = newParts.filter((part) => part.part_name.trim() !== "");

      // Convert interval_value to number if provided
      const intervalValue = newItem.interval_value ? Number(newItem.interval_value) : null;

      // Calculate due_date if interval is set
      let dueDate = null;
      if (newItem.interval_type && intervalValue) {
        const createdDate = new Date();

        if (newItem.interval_type === "day") {
          dueDate = new Date(createdDate.getTime() + intervalValue * 24 * 60 * 60 * 1000);
        } else if (newItem.interval_type === "week") {
          dueDate = new Date(createdDate.getTime() + intervalValue * 7 * 24 * 60 * 60 * 1000);
        } else if (newItem.interval_type === "month") {
          dueDate = new Date(createdDate.getTime() + intervalValue * 30 * 24 * 60 * 60 * 1000);
        }
      }

      const taskBody = {
        task_name: newItem.task_name,
        task_description: newItem.task_description,
        interval_type: newItem.interval_type || null,
        interval_value: intervalValue,
        due_date: dueDate ? dueDate.toISOString() : null,
        task_items: filteredTaskItems,
        section_id: newItem.section_id || null,
      };

      console.log("Creating task with raw JSON body:", JSON.stringify(taskBody, null, 2));

      // First create the task
      const response = await fetch(
        `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/sites/tasks/create?site_id=${site_id}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(taskBody),
        }
      );

      if (!response.ok) throw new Error("Failed to create task");

      const taskData = await response.json();
      const taskId = taskData.task_id;

      // Then add parts if any
      if (filteredParts.length > 0) {
        await Promise.all(
          filteredParts.map((part) =>
            fetch(`https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/parts/add`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                task_id: taskId,
                part_name: part.part_name,
                part_number: part.part_number,
                manufacturer: part.manufacturer,
                quantity: part.quantity,
                cost: part.cost,
              }),
            })
          )
        );
      }

      setAddDialogOpen(false);
      await fetchTasks();
      setNewItem({
        task_name: "",
        task_description: "",
        hours_usage: 0,
        maintenance_interval: 0,
        interval_type: null,
        interval_value: null,
        section_id: section_id || "", // Reset section_id
      });
      setNewTaskItems([""]);
      setNewParts([{ part_name: "", part_number: "", manufacturer: "", quantity: 1, cost: 0.0 }]);
    } catch (error) {
      console.error("Error creating task:", error);
    }
  };

  // Handle add task item
  const handleAddTaskItem = async () => {
    if (!currentItem || !newTaskItemText.trim()) return;

    try {
      const response = await fetch(
        `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/task-items/add`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            task_id: currentItem.id,
            item_text: newTaskItemText,
          }),
        }
      );

      if (!response.ok) throw new Error("Failed to add task item");

      const newTaskItem = await response.json();

      setCurrentItem((prev) => ({
        ...prev,
        items: [...prev.items, newTaskItem],
      }));

      setNewTaskItemText("");

      setMaintenanceItems((prevItems) =>
        prevItems.map((item) =>
          item.id === currentItem.id
            ? { ...item, taskitem_count: (item.taskitem_count || 0) + 1 }
            : item
        )
      );
    } catch (error) {
      console.error("Error adding task item:", error);
    }
  };

  // Handle upload photo
  const handleUploadPhoto = async (event) => {
    const file = event.target.files[0];
    if (!file || !currentItem) return;

    setUploadingPhoto(true);
    try {
      const urlResponse = await fetch(
        "https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/photos/generate-presigned-url",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            task_id: currentItem.id,
            site_id: site_id,
            file_name: file.name,
          }),
        }
      );

      const { upload_url, photo_id, s3_key } = await urlResponse.json();

      const uploadResult = await fetch(upload_url, {
        method: "PUT",
        body: file,
        headers: { "Content-Type": file.type },
      });

      if (!uploadResult.ok) throw new Error("Upload failed");

      const recordResponse = await fetch(
        "https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/photos/create-photo-record",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            photo_id,
            task_id: currentItem.id,
            s3_key,
            file_name: file.name,
          }),
        }
      );

      const newPhoto = await recordResponse.json();
      setCurrentPhotos((prev) => [newPhoto, ...prev]);
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Upload failed: " + error.message);
    } finally {
      setUploadingPhoto(false);
    }
  };

  const handleDeletePhoto = async (photoId) => {
    try {
      const response = await fetch(
        `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/photos/delete`,
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ photo_id: photoId }),
        }
      );

      if (!response.ok) throw new Error("Failed to delete photo");

      setCurrentPhotos((prevPhotos) => prevPhotos.filter((photo) => photo.photo_id !== photoId));
    } catch (error) {
      console.error("Error deleting photo:", error);
    }
  };

  const handleEditComment = (comment) => {
    setEditingComment(comment.comment_id);
    setEditedCommentText(comment.comment_text);
  };

  const handleSaveComment = async () => {
  if (!editingComment || !editedCommentText.trim()) return;

  try {
    const response = await fetch(
      "https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/comments/update",
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          comment_id: editingComment,
          comment_text: editedCommentText,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const updatedComment = await response.json();

    // Update the local state with the updated comment
    setCurrentComments((prev) =>
      prev.map((comment) =>
        comment.comment_id === editingComment ? updatedComment : comment
      )
    );

    setEditingComment(null);
    setEditedCommentText("");
  } catch (error) {
    console.error("Error updating comment:", error);
    alert("Failed to update comment: " + error.message);
  }
}; 

  // Handle add comment
  const handleAddComment = async () => {
    if (!currentItem) {
      console.error("No task selected for comment");
      return;
    }

    try {
      const response = await fetch(
        "https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/comments/add",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            task_id: currentItem.id,
            comment_text: newComment,
            created_by: userName || email,
          }),
        }
      );

      const data = await response.json();

      const newFormattedComment = {
        ...data,
        comment_text: newComment,
        created_by: userName || email,
        created_at: data.created_at || new Date().toISOString(),
      };

      setCurrentComments([newFormattedComment, ...currentComments]);
      setNewComment("");
      setMaintenanceItems((prevItems) =>
        prevItems.map((item) =>
          item.id === currentItem.id
            ? { ...item, comment_count: (item.comment_count || 0) + 1 }
            : item
        )
      );
    } catch (error) {
      console.error("Error adding comment:", error);
    }
  };

  // Handle open task dialog
  const handleOpenTaskDialog = async (taskId) => {
    try {
      const response = await fetch(
        `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/task-items?task_id=${taskId}`
      );
      if (!response.ok) throw new Error("Failed to fetch task items");
      const data = await response.json();

      const completions = data.reduce((acc, task) => {
        acc[task.item_id] = task.is_completed;
        return acc;
      }, {});

      const completedItems = data.filter((item) => item.is_completed).length;
      const totalItems = data.length;
      const completionPercentage = totalItems > 0 ? (completedItems / totalItems) * 100 : 0;

      setCurrentItem({
        id: taskId,
        items: data,
        completionPercentage: completionPercentage,
      });

      setTaskCompletions(completions);
      setTaskDialogOpen(true);
    } catch (error) {
      console.error("Error fetching task items:", error);
    }
  };

  // Handle open picture dialog
  const handleOpenPictureDialog = async (itemId) => {
    const item = maintenanceItems.find((item) => item.id === itemId);
    if (item) {
      setCurrentItem(item);
      setPictureDialogOpen(true);
      try {
        const response = await fetch(
          `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/photos?task_id=${item.id}`
        );
        if (!response.ok) throw new Error("Failed to fetch photos");
        const data = await response.json();
        setCurrentPhotos(data || []);
      } catch (error) {
        console.error("Error fetching photos:", error);
        setCurrentPhotos([]);
      }
    }
  };

  // Handle open parts dialog
  const handleOpenPartsDialog = async (taskId) => {
    const item = maintenanceItems.find((item) => item.id === taskId);
    if (item) {
      setCurrentItem(item);
      // Reset newPart when opening the dialog
      setNewPart({
        part_name: "",
        part_number: "",
        manufacturer: "",
        quantity: 1,
        cost: 0.0,
      });
      setPartsDialogOpen(true);
      try {
        const response = await fetch(
          `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/parts?task_id=${item.id}`
        );
        if (!response.ok) throw new Error("Failed to fetch parts");
        const data = await response.json();
        setCurrentParts(data || []);
      } catch (error) {
        console.error("Error fetching parts:", error);
        setCurrentParts([]);
      }
    }
  };

  // Handle add part
  const handleAddPart = async () => {
    try {
      const response = await fetch(
        "https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/parts/add",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            task_id: currentItem.id,
            ...newPart,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to add part");
      }

      const data = await response.json();

      setCurrentParts((prevParts) => [data, ...prevParts]);
      setNewPart({
        part_name: "",
        part_number: "",
        manufacturer: "",
        quantity: 1,
        cost: 0.0,
      });

      // Update the part count in the table
      setMaintenanceItems((prevItems) =>
        prevItems.map((item) =>
          item.id === currentItem.id ? { ...item, part_count: (item.part_count || 0) + 1 } : item
        )
      );
    } catch (error) {
      console.error("Error adding part:", error);
      alert("Failed to add part: " + error.message);
    }
  };

  const handleDeletePart = async (partId) => {
    try {
      await fetch(`https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/parts/delete`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          part_id: partId,
        }),
      });
      setCurrentParts((prev) => prev.filter((part) => part.part_id !== partId));

      // Update the part count in the table
      setMaintenanceItems((prevItems) =>
        prevItems.map((item) =>
          item.id === currentItem.id && item.part_count > 0
            ? { ...item, part_count: item.part_count - 1 }
            : item
        )
      );
    } catch (error) {
      console.error("Error deleting part:", error);
    }
  };

  // Handle update part
  const handleUpdatePart = async () => {
    try {
      const response = await fetch(
        "https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/parts/update",
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            part_id: editingPart.part_id,
            part_name: editingPart.part_name,
            quantity: editingPart.quantity,
            cost: editingPart.cost,
            manufacturer: editingPart.manufacturer,
            part_number: editingPart.part_number,
          }),
        }
      );

      if (!response.ok) throw new Error("Failed to update part");

      setCurrentParts((prev) =>
        prev.map((part) => (part.part_id === editingPart.part_id ? editingPart : part))
      );
      setEditingPart(null);
    } catch (error) {
      console.error("Error updating part:", error);
    }
  };

  const fetchStockItems = async () => {
    try {
      const response = await fetch(
        `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/stock-items?site_id=${site_id}`
      );
      const data = await response.json();
      setStockItems(data);
    } catch (error) {
      console.error("Error fetching stock items:", error);
    }
  };

  const handleOpenCommentsDialog = async (itemId) => {
    const item = maintenanceItems.find((item) => item.id === itemId);
    if (item) {
      setCurrentItem(item);
      setCommentsDialogOpen(true);
      try {
        const response = await fetch(
          `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/comments?task_id=${item.id}`
        );
        if (!response.ok) throw new Error("Failed to fetch comments");
        const data = await response.json();
        setCurrentComments(data || []);
      } catch (error) {
        console.error("Error fetching comments:", error);
        setCurrentComments([]);
      }
    }
  };

  const handleDeleteComment = async (commentId) => {
    try {
      await fetch(
        `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/comments/delete`,
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            comment_id: commentId,
          }),
        }
      );

      setCurrentComments((prev) => prev.filter((comment) => comment.comment_id !== commentId));

      if (currentItem) {
        setMaintenanceItems((prevItems) =>
          prevItems.map((item) =>
            item.id === currentItem.id && item.comment_count > 0
              ? { ...item, comment_count: item.comment_count - 1 }
              : item
          )
        );
      }
    } catch (error) {
      console.error("Error deleting comment:", error);
    }
  };

  const handleEditTaskItem = (taskId, itemId, itemText) => {
    setEditingTaskItem(itemId);
    setEditedTaskItemText(itemText);
  };

  const handleEditPart = (part) => {
    setEditingPart(part);
  };
  const handleCancelEdit = () => {
    setEditingPart(null);
  };
  const handleSaveTaskItem = async (taskId, itemId) => {
    try {
      const response = await fetch(
        `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/task-items/update`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            item_id: itemId,
            item_text: editedTaskItemText,
          }),
        }
      );

      if (!response.ok) throw new Error("Failed to update task item");

      setCurrentItem((prev) => ({
        ...prev,
        items: prev.items.map((item) =>
          item.item_id === itemId ? { ...item, item_text: editedTaskItemText } : item
        ),
      }));

      setEditingTaskItem(null);
      setEditedTaskItemText("");
    } catch (error) {
      console.error("Error updating task item:", error);
    }
  };

  const handleDeleteTaskItem = async (taskId, itemId) => {
    if (window.confirm("Are you sure you want to delete this task item?")) {
      try {
        await fetch(
          `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/task-items/delete`,
          {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              item_id: itemId,
            }),
          }
        );

        setCurrentItem((prev) => ({
          ...prev,
          items: prev.items.filter((item) => item.item_id !== itemId),
        }));

        if (currentItem) {
          setMaintenanceItems((prevItems) =>
            prevItems.map((item) =>
              item.id === currentItem.id && item.item_count > 0
                ? { ...item, item_count: item.item_count - 1 }
                : item
            )
          );
        }
      } catch (error) {
        console.error("Error deleting task item:", error);
      }
    }
  };

  const handleToggleTaskItemCompletion = async (taskId, itemId, isCompleted) => {
    try {
      const response = await fetch(
        `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/task-items/update`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            item_id: itemId,
            is_completed: !isCompleted,
          }),
        }
      );

      if (!response.ok) throw new Error("Failed to update task item completion");

      // Update local state first for better UX
      setTaskCompletions((prev) => ({
        ...prev,
        [itemId]: !isCompleted,
      }));

      setCurrentItem((prev) => {
        const updatedItems = prev.items.map((item) =>
          item.item_id === itemId ? { ...item, is_completed: !isCompleted } : item
        );

        // Check if all items are completed
        const allItemsCompleted = updatedItems.every((item) => item.is_completed);

        return {
          ...prev,
          items: updatedItems,
          status: allItemsCompleted ? "completed" : "pending",
        };
      });

      // Update the maintenance items list
      setMaintenanceItems((prevItems) =>
        prevItems.map((item) => {
          if (item.id === taskId) {
            const updatedCompletedItems = item.completed_items + (isCompleted ? -1 : 1);
            const allItemsCompleted = updatedCompletedItems === item.taskitem_count;

            return {
              ...item,
              completed_items: updatedCompletedItems,
              status: allItemsCompleted ? "completed" : "pending",
            };
          }
          return item;
        })
      );

      // If all items are now completed, update the task status on the server
      const task = maintenanceItems.find((item) => item.id === taskId);
      const updatedCompletedItems = task.completed_items + (isCompleted ? -1 : 1);
      if (updatedCompletedItems === task.taskitem_count) {
        await fetch("https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/update", {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            task_id: taskId,
            status: "completed",
            // Only send interval info if we're completing the task
            ...(task.interval_type && task.interval_value
              ? {
                  interval_type: task.interval_type,
                  interval_value: task.interval_value,
                }
              : {}),
          }),
        });
      }
    } catch (error) {
      console.error("Error updating task item completion:", error);
    }
  };

  const handleUpdateItem = async () => {
    try {
      if (!editingItem) return;

      // Calculate due_date if interval is set
      let dueDate = null;
      if (editingItem.interval_type && editingItem.interval_value) {
        const now = new Date();
        const intervalValue = Number(editingItem.interval_value);

        if (editingItem.interval_type === "day") {
          dueDate = new Date(now.getTime() + intervalValue * 24 * 60 * 60 * 1000);
        } else if (editingItem.interval_type === "week") {
          dueDate = new Date(now.getTime() + intervalValue * 7 * 24 * 60 * 60 * 1000);
        } else if (editingItem.interval_type === "month") {
          dueDate = new Date(now.getTime() + intervalValue * 30 * 24 * 60 * 60 * 1000);
        }
      }

      const response = await fetch(
        `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/update`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            task_id: editingItem.id,
            task_name: editingItem.item,
            interval_type: editingItem.interval_type || null,
            interval_value: editingItem.interval_value || null,
            due_date: dueDate ? dueDate.toISOString() : null,
          }),
        }
      );

      if (!response.ok) throw new Error("Failed to update task");

      setEditDialogOpen(false);
      await fetchTasks(); // Refresh the data
    } catch (error) {
      console.error("Error updating task:", error);
    }
  };

  // Then modify your handleAddBreakdown to use it:
  const handleAddBreakdown = async () => {
    if (!currentItem || !newBreakdownDescription) return;

    try {
      const formattedDate = newBreakdownDate ? new Date(newBreakdownDate).toISOString() : null;

      console.log("Sending breakdown data:", {
        task_id: currentItem.id,
        description: newBreakdownDescription,
        breakdown_date: formattedDate,
      });

      const response = await fetch(
        `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/breakdowns/add`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            task_id: currentItem.id,
            description: newBreakdownDescription,
            breakdown_date: formattedDate,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(responseData.error || "Failed to add breakdown");
      }

      // Close the dialog and refresh the tasks
      setBreakdownsDialogOpen(false);
      fetchTasks();
    } catch (error) {
      console.error("Full error details:", error);
      alert(`Error: ${error.message}`);
    }
  };

  const handleEditBreakdown = async (taskId, breakdownId, description, date) => {
    try {
      const formattedDate = date ? new Date(date).toISOString() : null;

      const response = await fetch(
        `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/breakdowns/update`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            breakdown_id: breakdownId,
            description,
            breakdown_date: formattedDate,
          }),
        }
      );

      if (!response.ok) throw new Error("Failed to update breakdown");

      setCurrentItem((prev) => ({
        ...prev,
        breakdowns: prev.breakdowns.map((bd) =>
          bd.breakdown_id === breakdownId
            ? {
                ...bd,
                description,
                breakdown_date: formattedDate,
              }
            : bd
        ),
      }));
    } catch (error) {
      console.error("Error updating breakdown:", error);
    }
  };

  const handleDeleteBreakdown = async (breakdownId) => {
    if (window.confirm("Are you sure you want to delete this breakdown?")) {
      try {
        await fetch(
          `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/tasks/breakdowns/delete?breakdown_id=${breakdownId}`,
          {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
          }
        );

        setCurrentItem((prev) => ({
          ...prev,
          breakdowns: prev.breakdowns.filter((bd) => bd.breakdown_id !== breakdownId),
        }));
      } catch (error) {
        console.error("Error deleting breakdown:", error);
      }
    }
  };
  useEffect(() => {
    if (selectedStockItem) {
      const updatedParts = [...newParts];
      const currentPartIndex = updatedParts.length - 1; // Assuming we're working with the last part
      updatedParts[currentPartIndex] = {
        ...updatedParts[currentPartIndex],
        part_name: selectedStockItem.component || "",
        manufacturer: selectedStockItem.manufacturer || "",
        part_number: selectedStockItem.part_number || "",
        quantity: 1,
        cost: selectedStockItem.cost || 0.0,
      };
      setNewParts(updatedParts);
      setSelectedStockItem(null);
    }
  }, [selectedStockItem]);

  // Columns for the table
  const columns = [
    { name: "Item", align: "left" },
    { name: "Interval", align: "center" },
    { name: "Last Completion Date", align: "center" },
    { name: "Due Date", align: "center" },
    { name: "Completion", align: "center" },
    { name: "Breakdowns", align: "center" },
    { name: "Comments", align: "center" },
    { name: "Task List", align: "center" },
    { name: "Pictures", align: "center" },
    { name: "Parts", align: "center" },
    { name: "Actions", align: "center" },
  ];

  // Rows for the table
  const rows = maintenanceItems.slice((page - 1) * rowsPerPage, page * rowsPerPage).map((item) => {
    const intervalText =
      item.interval_type && item.interval_value
        ? `${item.interval_value} ${item.interval_type}`
        : "No interval set";

    let dueDateText = "Not set";
    if (item.due_date) {
      const dueDate = new Date(item.due_date);
      dueDateText = dueDate.toLocaleDateString();

      // Highlight differently based on status and due date
      const isOverdue = item.status !== "completed" && dueDate < new Date();
      const isDueSoon =
        item.status !== "completed" &&
        dueDate < new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000);

      if (isOverdue) {
        dueDateText = (
          <span style={{ color: "red", fontWeight: "bold" }}>{dueDateText} (Overdue)</span>
        );
      } else if (isDueSoon) {
        dueDateText = (
          <span style={{ color: "orange", fontWeight: "bold" }}>{dueDateText} (Due Soon)</span>
        );
      }
    } else if (item.interval_type && item.interval_value && item.created_at) {
      // Calculate due date from interval if not explicitly set
      const intervalValue = parseInt(item.interval_value);
      const createdDate = new Date(item.created_at);
      let dueDate;

      switch (item.interval_type) {
        case "day":
          dueDate = new Date(createdDate.getTime() + intervalValue * 24 * 60 * 60 * 1000);
          break;
        case "week":
          dueDate = new Date(createdDate.getTime() + intervalValue * 7 * 24 * 60 * 60 * 1000);
          break;
        case "month":
          dueDate = new Date(createdDate.getTime() + intervalValue * 30 * 24 * 60 * 60 * 1000);
          break;
      }

      if (dueDate) {
        dueDateText = dueDate.toLocaleDateString();
        const isOverdue = item.status !== "completed" && dueDate < new Date();
        if (isOverdue) {
          dueDateText = <span style={{ color: "red" }}>{dueDateText} (Overdue)</span>;
        }
      }
    }

    const completionDate = item.completed_at
      ? new Date(item.completed_at).toLocaleDateString()
      : "Not completed";

    // Add breakdown information
    const breakdownText = item.breakdown_description ? (
      <VuiTypography variant="caption" color="text">
        {item.breakdown_date ? new Date(item.breakdown_date).toLocaleDateString() : "No date"} -{" "}
        {item.breakdown_description}
      </VuiTypography>
    ) : (
      "No breakdown"
    );
    const completion = `${Math.round(
      ((item.completed_items || 0) / (item.taskitem_count || 1)) * 100
    )}%`;

    return {
      Item: item.item,
      Interval: intervalText,
      "Due Date": dueDateText,
      Breakdowns: (
        <VuiButton
          color="info"
          onClick={() => {
            setCurrentItem(item);
            setBreakdownsDialogOpen(true);
          }}
          sx={{
            minWidth: "100px", // Ensure consistent button width
          }}
        >
          {item.breakdowns?.length || 0} Breakdowns
        </VuiButton>
      ),
      Completion: completion,
      "Last Completion Date": completionDate,

      Comments: (
        <VuiButton color="info" onClick={() => handleOpenCommentsDialog(item.id)}>
          {item.comment_count || 0} Comments
        </VuiButton>
      ),
      "Task List": (
        <VuiButton color="info" onClick={() => handleOpenTaskDialog(item.id)}>
          {item.taskitem_count || 0} Items
        </VuiButton>
      ),
      Pictures: (
        <VuiButton color="info" onClick={() => handleOpenPictureDialog(item.id)}>
          {item.photo_count || 0} Photos
        </VuiButton>
      ),
      Parts: (
        <VuiButton color="info" onClick={() => handleOpenPartsDialog(item.id)}>
          {item.part_count || 0} Parts
        </VuiButton>
      ),
      Actions: (
        <>
          <IconButton
            color="info"
            onClick={(e) => {
              e.stopPropagation();
              handleOpenEditDialog(item);
            }}
          >
            <Icon>edit</Icon>
          </IconButton>
          <Checkbox
            checked={item.status === "completed"}
            onChange={() => handleCompleteTask(item.id, item.status)}
            color="success"
            sx={{
              border: "1px solid grey",
              borderRadius: "5px",
              "&.Mui-checked": {
                border: "1px solid green",
              },
            }}
          />
          <IconButton color="error" onClick={() => handleDeleteTask(item.id)}>
            <Icon>delete</Icon>
          </IconButton>
        </>
      ),
    };
  });
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        <Card>
          <VuiBox display="flex" justifyContent="space-between" alignItems="center" p={2}>
            <VuiTypography variant="lg" color="white">
              Maintenance Tasks - {sectionName || siteName}
            </VuiTypography>
            <div>
              <VuiButton
                variant="contained"
                color="info"
                onClick={() => navigate(`/ppm-data-export/${site_id}`)}
                sx={{ mr: 2 }}
              >
                <Icon>download</Icon>&nbsp; Export PPM Data
              </VuiButton>
              <VuiButton variant="contained" color="primary" onClick={() => setAddDialogOpen(true)}>
                <Icon>add</Icon>&nbsp; Add Task
              </VuiButton>
            </div>
          </VuiBox>
          {loading ? (
            <VuiBox display="flex" justifyContent="center" py={4}>
              <CircularProgress />
            </VuiBox>
          ) : (
            <Table columns={columns} rows={rows} />
          )}
          {maintenanceItems.length > 0 && (
            <VuiBox display="flex" justifyContent="center" p={2}>
              <VuiPagination>
                <VuiPagination
                  item
                  onClick={() => setPage(Math.max(1, page - 1))}
                  disabled={page === 1}
                >
                  <Icon>keyboard_arrow_left</Icon>
                </VuiPagination>
                {Array.from(
                  { length: Math.ceil(maintenanceItems.length / rowsPerPage) },
                  (_, i) => (
                    <VuiPagination
                      key={i + 1}
                      item
                      active={page === i + 1}
                      onClick={() => setPage(i + 1)}
                    >
                      {i + 1}
                    </VuiPagination>
                  )
                )}
                <VuiPagination
                  item
                  onClick={() =>
                    setPage(Math.min(Math.ceil(maintenanceItems.length / rowsPerPage), page + 1))
                  }
                  disabled={page === Math.ceil(maintenanceItems.length / rowsPerPage)}
                >
                  <Icon>keyboard_arrow_right</Icon>
                </VuiPagination>
              </VuiPagination>
            </VuiBox>
          )}
        </Card>
      </VuiBox>
      {/* Add Task Dialog */}
      <Dialog open={addDialogOpen} onClose={() => setAddDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Add New Maintenance Task</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Item"
                margin="dense"
                value={newItem.task_name}
                onChange={(e) => setNewItem({ ...newItem, task_name: e.target.value })}
                required
                sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                InputLabelProps={{
                  shrink: true, // Always keep label in top-left

                  style: { fontSize: "0.875rem" },
                }}
                InputProps={{
                  style: { fontSize: "0.875rem" },
                  min: 0,
                  width: '100%'
                }}
              />
            </Grid>
            <Grid item xs={6} md={3} onClick={handleGridClick} style={{ cursor: "pointer" }}>
              <FormControl fullWidth margin="dense">
                <InputLabel id="interval-type-label" shrink style={{ fontSize: "0.875rem" }}>
                  Interval Type
                </InputLabel>
                <Select
                  labelId="interval-type-label"
                  value={newItem.interval_type || ""}
                  onChange={(e) => setNewItem({ ...newItem, interval_type: e.target.value })}
                  onOpen={() => setOpen(true)}
                  onClose={() => setOpen(false)}
                  open={open}
                  label="Interval Type"
                  inputProps={{
                    style: { fontSize: "0.875rem" },
                  }}
                >
                  <MenuItem value="day">Day</MenuItem>
                  <MenuItem value="week">Week</MenuItem>
                  <MenuItem value="month">Month</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                fullWidth
                type="number"
                label="Interval Value"
                margin="dense"
                value={newItem.interval_value || ""}
                onChange={(e) => setNewItem({ ...newItem, interval_value: e.target.value })}
                sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                InputLabelProps={{
                  shrink: true,
                  style: { fontSize: "0.875rem" },
                }}
                InputProps={{
                  style: { fontSize: "0.875rem", width: '100%' },
                }}
              />
            </Grid>

            {/* Task Items Section */}
            <Grid item xs={12}>
              <VuiTypography variant="subtitle2" mt={2} mb={1}>
                Task List
              </VuiTypography>
              {newTaskItems.map((item, index) => (
                <Grid container spacing={1} key={index} alignItems="center" mb={1}>
                  <Grid item xs={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label={`Task Item ${index + 1}`}
                      value={item}
                      onChange={(e) => {
                        const updatedItems = [...newTaskItems];
                        updatedItems[index] = e.target.value;
                        setNewTaskItems(updatedItems);
                      }}
                       sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                      InputLabelProps={{
                        shrink: true,
                        style: { fontSize: "0.875rem" },
                      }}
                      InputProps={{
                        style: { fontSize: "0.875rem", width: '100%'},
                      }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <IconButton
                      color="error"
                      onClick={() => {
                        const updatedItems = newTaskItems.filter((_, i) => i !== index);
                        setNewTaskItems(updatedItems);
                      }}
                      disabled={newTaskItems.length === 1}
                    >
                      <Icon>delete</Icon>
                    </IconButton>
                  </Grid>
                </Grid>
              ))}
              <Grid container item xs={12} justifyContent="flex-start">
                <Grid item xs={3}>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    startIcon={<Icon>add</Icon>}
                    onClick={() => setNewTaskItems([...newTaskItems, ""])}
                    fullWidth
                    sx={{
                      borderColor: "blue",
                      color: "white",
                      backgroundColor: "blue",
                      "&:hover": {
                        backgroundColor: "#0048aa", // darker blue on hover
                        borderColor: "#0048aa",
                        mt: 1,
                      },
                    }}
                  >
                    Add Task Item
                  </Button>
                </Grid>
              </Grid>
            </Grid>

            {/* Parts Section */}
            <Grid item xs={12}>
              <VuiTypography variant="subtitle2" mt={2} mb={1}>
                Parts (Optional)
              </VuiTypography>

              {newParts.map((part, index) => (
                <Grid container spacing={1} key={index} alignItems="center" mb={1}>
                  {" "}
                  <Grid item xs={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Component"
                      value={part.part_name}
                      onChange={(e) => {
                        const updatedParts = [...newParts];
                        updatedParts[index] = { ...updatedParts[index], part_name: e.target.value };
                        setNewParts(updatedParts);
                      }}
                      sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                      InputLabelProps={{
                        shrink: true,
                        style: { fontSize: "0.875rem" },
                      }}
                      InputProps={{
                        style: { fontSize: "0.875rem", width: '100%'  },
                      }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Manufacturer"
                      value={part.manufacturer}
                      onChange={(e) => {
                        const updatedParts = [...newParts];
                        updatedParts[index] = {
                          ...updatedParts[index],
                          manufacturer: e.target.value,
                        };
                        setNewParts(updatedParts);
                      }}
                      sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                      InputLabelProps={{
                        shrink: true,
                        style: { fontSize: "0.875rem" },
                      }}
                      InputProps={{
                        style: { fontSize: "0.875rem", width: '100%' },
                      }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Part No."
                      value={part.part_number}
                      onChange={(e) => {
                        const updatedParts = [...newParts];
                        updatedParts[index] = {
                          ...updatedParts[index],
                          part_number: e.target.value,
                        };
                        setNewParts(updatedParts);
                      }}
                      sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                      InputLabelProps={{
                        shrink: true,
                        style: { fontSize: "0.875rem" },
                      }}
                      InputProps={{
                        style: { fontSize: "0.875rem", width: '100%' },
                      }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      label="Qty"
                      value={part.quantity}
                      onChange={(e) => {
                        const updatedParts = [...newParts];
                        updatedParts[index] = {
                          ...updatedParts[index],
                          quantity: Math.max(1, parseInt(e.target.value) || 1),
                        };
                        setNewParts(updatedParts);
                      }}
                      sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                      InputLabelProps={{
                        shrink: true,
                        style: { fontSize: "0.875rem" },
                      }}
                      InputProps={{
                        style: { fontSize: "0.875rem", width: '100%' },
                      }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      label="Cost"
                      value={part.cost}
                      onChange={(e) => {
                        const updatedParts = [...newParts];
                        updatedParts[index] = {
                          ...updatedParts[index],
                          cost: parseFloat(e.target.value) || 0.0,
                        };
                        setNewParts(updatedParts);
                      }}
                      sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                      InputProps={{
                        shrink: true,
                        startAdornment: <InputAdornment position="start">£</InputAdornment>,
                        inputProps: { min: 0 },
                        style: { fontSize: "0.875rem" },
                      }}
                      InputLabelProps={{
                        style: { fontSize: "0.875rem", width: '100%' },
                      }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <IconButton
                      color="error"
                      onClick={() => {
                        const updatedParts = newParts.filter((_, i) => i !== index);
                        setNewParts(updatedParts);
                      }}
                      disabled={newParts.length === 1}
                    >
                      <Icon>delete</Icon>
                    </IconButton>
                  </Grid>
                </Grid>
              ))}
              <Grid container item xs={12} spacing={2} justifyContent="flex-start">
                <Grid item xs={3}>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    startIcon={<Icon>add</Icon>}
                    onClick={() =>
                      setNewParts([
                        ...newParts,
                        {
                          part_name: "",
                          part_number: "",
                          manufacturer: "",
                          quantity: 1,
                          cost: 0.0,
                        },
                      ])
                    }
                    fullWidth
                    sx={{
                      borderColor: "blue",
                      color: "white",
                      backgroundColor: "blue",
                      "&:hover": {
                        backgroundColor: "#0048aa",
                        borderColor: "#0048aa",
                      },
                    }}
                  >
                    Add Part
                  </Button>
                </Grid>
                <Grid item xs={3}>
                  <Button
                    variant="outlined"
                    size="small"
                    fullWidth
                    onClick={() => setStockDialogOpen(true)}
                    sx={{
                      borderColor: "blue",
                      color: "white",
                      backgroundColor: "blue",
                      "&:hover": {
                        backgroundColor: "#0048aa",
                        borderColor: "#0048aa",
                      },
                    }}
                  >
                    Select from Stock
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddDialogOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleAddItem} color="primary" disabled={!newItem.task_name}>
            Create Task
          </Button>
        </DialogActions>
      </Dialog>
      {/* Task Checklist Dialog */}
      <Dialog
        open={taskDialogOpen}
        onClose={() => setTaskDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{currentItem?.item} Checklist</DialogTitle>
        <DialogContent>
          {currentItem?.description && (
            <VuiBox mb={3}>
              <VuiTypography variant="body2" color="text">
                {currentItem.description}
              </VuiTypography>
            </VuiBox>
          )}
          <List>
            {currentItem?.items && currentItem.items.length > 0 ? (
              currentItem.items.map((task) => (
                <ListItem key={task.item_id}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!taskCompletions[task.item_id]}
                        onChange={() =>
                          handleToggleTaskItemCompletion(
                            currentItem.id,
                            task.item_id,
                            taskCompletions[task.item_id]
                          )
                        }
                        color="primary"
                      />
                    }
                    label={
                      editingTaskItem === task.item_id ? (
                        <TextField
                          fullWidth
                          value={editedTaskItemText}
                          onChange={(e) => setEditedTaskItemText(e.target.value)}
                          autoFocus
                          sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                          InputProps={{ style: { fontSize: "0.875rem", width: '100%' } }}
                          InputLabelProps={{ style: { fontSize: "0.875rem" } }}
                        />
                      ) : (
                        <ListItemText
                          primaryTypographyProps={{ style: { fontSize: "0.875rem" } }}
                          primary={task.item_text}
                          style={{
                            textDecoration: taskCompletions[task.item_id] ? "line-through" : "none",
                          }}
                        />
                      )
                    }
                  />

                  {editingTaskItem === task.item_id ? (
                    <>
                      <IconButton
                        onClick={() => handleSaveTaskItem(currentItem.id, task.item_id)}
                        color="primary"
                      >
                        <Icon>check</Icon>
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          setEditingTaskItem(null);
                          setEditedTaskItemText(""); // or reset to task.item_text if needed
                        }}
                        color="default"
                      >
                        <Icon>close</Icon>
                      </IconButton>
                    </>
                  ) : (
                    <>
                      <IconButton
                        onClick={() =>
                          handleEditTaskItem(currentItem.id, task.item_id, task.item_text)
                        }
                        color="primary"
                      >
                        <Icon>edit</Icon>
                      </IconButton>

                      <IconButton
                        onClick={() => handleDeleteTaskItem(currentItem.id, task.item_id)}
                        color="error"
                      >
                        <Icon>delete</Icon>
                      </IconButton>
                    </>
                  )}
                </ListItem>
              ))
            ) : (
              <VuiBox textAlign="center" py={2}>
                <VuiTypography variant="body2" color="text">
                  No checklist items for this task.
                </VuiTypography>
              </VuiBox>
            )}
          </List>

          {/* Breakdowns Section */}
          <VuiBox mt={3}>
            <VuiTypography variant="subtitle2" mb={1}>
              Breakdowns
            </VuiTypography>
            {currentItem?.breakdowns?.length > 0 ? (
              <List>
                {currentItem.breakdowns.map((breakdown) => (
                  <ListItem
                    key={breakdown.breakdown_id}
                    secondaryAction={
                      <>
                        {editingBreakdown === breakdown.breakdown_id ? (
                          <>
                            <IconButton
                              edge="end"
                              onClick={() => {
                                handleEditBreakdown(
                                  currentItem.id,
                                  breakdown.breakdown_id,
                                  editedBreakdownDescription,
                                  editedBreakdownDate
                                );
                                setEditingBreakdown(null);
                              }}
                              color="primary"
                            >
                              <Icon>check</Icon>
                            </IconButton>
                            <IconButton
                              edge="end"
                              onClick={() => setEditingBreakdown(null)}
                              color="secondary"
                            >
                              <Icon>close</Icon>
                            </IconButton>
                          </>
                        ) : (
                          <IconButton
                            edge="end"
                            onClick={() => {
                              setEditingBreakdown(breakdown.breakdown_id);
                              setEditedBreakdownDescription(breakdown.description);
                              setEditedBreakdownDate(
                                breakdown.breakdown_date
                                  ? new Date(breakdown.breakdown_date).toISOString().split("T")[0]
                                  : ""
                              );
                            }}
                            color="primary"
                          >
                            <Icon>edit</Icon>
                          </IconButton>
                        )}
                        <IconButton
                          edge="end"
                          onClick={() => handleDeleteBreakdown(breakdown.breakdown_id)}
                          color="error"
                        >
                          <Icon>delete</Icon>
                        </IconButton>
                      </>
                    }
                  >
                    {editingBreakdown === breakdown.breakdown_id ? (
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="Description"
                            sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                            value={editedBreakdownDescription}
                            onChange={(e) => setEditedBreakdownDescription(e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="Date"
                            type="date"
                            sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                            InputLabelProps={{ shrink: true }}
                            value={editedBreakdownDate}
                            onChange={(e) => setEditedBreakdownDate(e.target.value)}
                            inputProps={{
                              max: new Date().toISOString().split("T")[0],
                            }}
                          />
                        </Grid>
                      </Grid>
                    ) : (
                      <ListItemText
                        primary={breakdown.description}
                        secondary={
                          breakdown.breakdown_date
                            ? `Date: ${new Date(breakdown.breakdown_date).toLocaleDateString()}`
                            : "No date specified"
                        }
                      />
                    )}
                  </ListItem>
                ))}
              </List>
            ) : (
              <VuiTypography variant="body2" color="text">
                No breakdowns for this task.
              </VuiTypography>
            )}
          </VuiBox>

          <TextField
            fullWidth
            variant="outlined"
            label="New Task Item"
            value={newTaskItemText}
            onChange={(e) => setNewTaskItemText(e.target.value)}
            sx={{ mt: 2,'& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' }  }}
            InputLabelProps={{ shrink: true, style: { fontSize: "0.875rem" } }}
            InputProps={{
              style: { fontSize: "0.875rem", width: '100%' },
            }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddTaskItem}
            fullWidth
            sx={{ mt: 2 }}
          >
            Add New Task Item
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setTaskDialogOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      ;{/* Photos Dialog */}
      <Dialog
        open={pictureDialogOpen}
        onClose={() => setPictureDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{currentItem?.item} Photos</DialogTitle>
        <DialogContent>
          {currentPhotos.length > 0 ? (
            <ImageList>
              {currentPhotos.map((photo) => (
                <ImageListItem key={photo.photo_id}>
                  <img src={photo.url} alt={photo.file_name} />
                  <IconButton
                    color="error"
                    onClick={() => handleDeletePhoto(photo.photo_id)}
                    sx={{ position: "absolute", top: 5, right: 5 }}
                  >
                    <Icon>delete</Icon>
                  </IconButton>
                </ImageListItem>
              ))}
            </ImageList>
          ) : (
            <VuiBox textAlign="center" py={4}>
              <VuiTypography variant="body2" color="text">
                No photos available for this task.
              </VuiTypography>
            </VuiBox>
          )}
          <VuiBox mt={3}>
            <Button
              variant="contained"
              component="label"
              fullWidth
              color="primary"
              disabled={uploadingPhoto}
              startIcon={<Icon>add_a_photo</Icon>}
            >
              {uploadingPhoto ? "Uploading..." : "Upload Photo"}
              <input
                type="file"
                hidden
                onChange={handleUploadPhoto}
                accept="image/*"
                disabled={uploadingPhoto}
              />
            </Button>
          </VuiBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPictureDialogOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {/* Parts Dialog */}
      <Dialog
        open={partsDialogOpen}
        onClose={() => {
          setPartsDialogOpen(false);
          fetchTasks(); // Refresh the table data when dialog closes
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{currentItem?.item} Parts</DialogTitle>
        <DialogContent>
          {currentParts.length > 0 ? (
            <List>
              {currentParts.map((part) => (
                <ListItem key={part.part_id}>
                  {editingPart?.part_id === part.part_id ? (
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} md={3}>
                        <TextField
                          fullWidth
                          label="Component"
                          value={editingPart.part_name}
                          onChange={(e) =>
                            setEditingPart({ ...editingPart, part_name: e.target.value })
                          }
                          required
                          margin="dense"
                          sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                          InputLabelProps={{
                            shrink: true,
                            style: { fontSize: "0.875rem" },
                          }}
                          InputProps={{ style: { fontSize: "0.875rem", width: '100%' } }}
                        />
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <TextField
                          fullWidth
                          label="Manufacturer"
                          value={editingPart.manufacturer}
                          onChange={(e) =>
                            setEditingPart({ ...editingPart, manufacturer: e.target.value })
                          }
                          margin="dense"
                          sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                          InputLabelProps={{ shrink: true, style: { fontSize: "0.875rem" } }}
                          InputProps={{ style: { fontSize: "0.875rem", width: '100%' } }}
                        />
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <TextField
                          fullWidth
                          label="Part No."
                          value={editingPart.part_number}
                          onChange={(e) =>
                            setEditingPart({ ...editingPart, part_number: e.target.value })
                          }
                          margin="dense"
                          sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                          InputLabelProps={{ shrink: true, style: { fontSize: "0.875rem" } }}
                          InputProps={{ style: { fontSize: "0.875rem", width: '100%' } }}
                        />
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <TextField
                          fullWidth
                          type="number"
                          label="Quantity"
                          value={editingPart.quantity}
                          onChange={(e) =>
                            setEditingPart({ ...editingPart, quantity: e.target.value })
                          }
                          required
                          margin="dense"
                          sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                          InputLabelProps={{ shrink: true, style: { fontSize: "0.875rem" } }}
                          InputProps={{ style: { fontSize: "0.875rem" }, min: 0 , width: '100%'}}
                        />
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <TextField
                          fullWidth
                          type="number"
                          label="Cost"
                          value={editingPart.cost}
                          onChange={(e) => setEditingPart({ ...editingPart, cost: e.target.value })}
                          sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                          InputProps={{
                            startAdornment: <InputAdornment position="start">£</InputAdornment>,
                            inputProps: { min: 0, width: '100%' },
                          }}
                          InputLabelProps={{ shrink: true, style: { fontSize: "0.875rem" } }}
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={12} display="flex" justifyContent="flex-end" gap={0.5}>
                        <IconButton onClick={handleUpdatePart} color="primary" size="small">
                          <Icon fontSize="small">check</Icon>
                        </IconButton>
                        <IconButton onClick={handleCancelEdit} color="secondary" size="small">
                          <Icon fontSize="small">close</Icon>
                        </IconButton>
                      </Grid>
                    </Grid>
                  ) : (
                    <>
                      <ListItemText
                        primaryTypographyProps={{ fontSize: "0.875rem" }}
                        secondaryTypographyProps={{ fontSize: "0.75rem" }}
                        primary={`${part.part_name} ( ${part.manufacturer} - ${part.part_number})`}
                        secondary={`Quantity: ${part.quantity} - Cost: £${part.cost}`}
                      />
                      <IconButton
                        onClick={() => handleEditPart(part)}
                        color="primary"
                        size="small"
                        sx={{ mr: 1 }}
                      >
                        <Icon>edit</Icon>
                      </IconButton>
                      <IconButton
                        onClick={() => handleDeletePart(part.part_id)}
                        color="error"
                        size="small"
                      >
                        <Icon>delete</Icon>
                      </IconButton>
                    </>
                  )}
                </ListItem>
              ))}
            </List>
          ) : (
            <VuiBox textAlign="center" py={4}>
              <VuiTypography variant="body2" color="text">
                No parts available for this task.
              </VuiTypography>
            </VuiBox>
          )}

          <VuiBox mt={4} mb={2}>
            <VuiTypography variant="h6" color="textPrimary">
              Add New Part
            </VuiTypography>
          </VuiBox>

          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12}>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setStockDialogOpen(true)}
                startIcon={<Icon>inventory</Icon>}
                sx={{
                  borderColor: "blue",
                  color: "white",
                  backgroundColor: "blue",
                  "&:hover": {
                    backgroundColor: "#0048aa",
                    borderColor: "#0048aa",
                    mb: 2,
                  },
                  mb: 2,
                }}
              >
                Select from Stock
              </Button>
            </Grid>
          </Grid>

          <VuiBox>
            <TextField
              fullWidth
              label="Component"
              margin="dense"
              value={newPart.part_name}
              onChange={(e) => setNewPart({ ...newPart, part_name: e.target.value })}
              sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
              InputLabelProps={{ shrink: true, style: { fontSize: "0.875rem" } }}
              InputProps={{ style: { fontSize: "0.875rem", width: '100%' } }}
            />
            <TextField
              fullWidth
              label="Manufacturer"
              margin="dense"
              value={newPart.manufacturer}
              onChange={(e) => setNewPart({ ...newPart, manufacturer: e.target.value })}
              sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
              InputLabelProps={{ shrink: true, style: { fontSize: "0.875rem" } }}
              InputProps={{ style: { fontSize: "0.875rem" }, width: '100%' }}
            />
            <TextField
              fullWidth
              label="Part No."
              margin="dense"
              value={newPart.part_number}
              onChange={(e) => setNewPart({ ...newPart, part_number: e.target.value })}
              sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
              InputLabelProps={{ shrink: true, style: { fontSize: "0.875rem" } }}
              InputProps={{ style: { fontSize: "0.875rem" }, width: '100%' }}
            />
            <TextField
              fullWidth
              type="number"
              label="Quantity"
              margin="dense"
              value={newPart.quantity}
              onChange={(e) => setNewPart({ ...newPart, quantity: e.target.value })}
              sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
              inputProps={{ shrink: true, min: 0, fontSize: "0.875rem" , width: '100%'}}
              InputLabelProps={{ style: { fontSize: "0.875rem" } }}
            />
            <TextField
              fullWidth
              type="number"
              label="Cost"
              margin="dense"
              value={newPart.cost}
              onChange={(e) => setNewPart({ ...newPart, cost: parseFloat(e.target.value) || 0.0 })}
              sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
              InputProps={{
                startAdornment: <InputAdornment position="start">£</InputAdornment>,
                inputProps: { min: 0, fontSize: "0.875rem" }, width: '100%'
              }}
              InputLabelProps={{ style: { fontSize: "0.875rem" } }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddPart}
              fullWidth
              sx={{ mt: 2 }}
            >
              Add Part
            </Button>
          </VuiBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPartsDialogOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {/* Comments Dialog */}
      <Dialog
        open={commentsDialogOpen}
        onClose={() => {
          setCommentsDialogOpen(false);
          setEditingComment(null);
          setEditedCommentText("");
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Task Comments</DialogTitle>
        <DialogContent>
          <List>
            {currentComments.map((comment) => (
              <ListItem key={comment.comment_id}>
                {editingComment === comment.comment_id ? (
                  <>
                    <TextField
                      fullWidth
                      multiline
                      value={editedCommentText}
                      onChange={(e) => setEditedCommentText(e.target.value)}
                      sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                      InputProps={{ style: { fontSize: "0.875rem" }, width: '100%' }}
                    />
                    <IconButton onClick={handleSaveComment} color="primary">
                      <Icon>check</Icon>
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        setEditingComment(null);
                        setEditedCommentText("");
                      }}
                      color="secondary"
                    >
                      <Icon>close</Icon>
                    </IconButton>
                  </>
                ) : (
                  <>
                    <ListItemText
                      primary={comment.comment_text}
                      primaryTypographyProps={{ style: { fontSize: "0.875rem" } }}
                      secondary={`At ${new Date(comment.created_at).toLocaleString()} By ${
                        comment.created_by
                      }`}
                      secondaryTypographyProps={{ style: { fontSize: "0.75rem" } }}
                    />
                    <IconButton
                      onClick={() => handleEditComment(comment)}
                      color="primary"
                      sx={{ mr: 1 }}
                    >
                      <Icon>edit</Icon>
                    </IconButton>
                    <IconButton
                      onClick={() => handleDeleteComment(comment.comment_id)}
                      color="error"
                    >
                      <Icon>delete</Icon>
                    </IconButton>
                  </>
                )}
              </ListItem>
            ))}
          </List>
          <TextField
            fullWidth
            multiline
            rows={2}
            variant="outlined"
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            placeholder="Add new comment..."
            sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
            InputProps={{ style: { fontSize: "0.875rem" } }}
            InputLabelProps={{ style: { fontSize: "0.875rem" }, width: '100%' }}
          />
          <Button variant="contained" color="primary" onClick={handleAddComment} sx={{ mt: 2 }}>
            Add Comment
          </Button>
        </DialogContent>
      </Dialog>
      {/* Edit Item Dialog */}
      <Dialog
        open={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Edit Maintenance Task</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Item Name"
                value={editingItem?.item || ""}
                onChange={(e) => setEditingItem({ ...editingItem, item: e.target.value })}
                sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                InputLabelProps={{ shrink: true, style: { fontSize: "0.875rem" } }}
                          InputProps={{ style: { fontSize: "0.875rem" }, width: '100%' }}
              />
            </Grid>
            <Grid item xs={6} onClick={handleGridClick} style={{ cursor: "pointer" }}>
              <FormControl fullWidth margin="dense">
                <InputLabel id="edit-interval-type-label" shrink style={{ fontSize: "0.875rem" }}>Interval Type</InputLabel>
                <Select
                  labelId="edit-interval-type-label"
                  id="edit-interval-type-select"
                  value={editingItem?.interval_type || ""}
                  onChange={(e) =>
                    setEditingItem({
                      ...editingItem,
                      interval_type: e.target.value,
                    })
                  }
                  onOpen={() => setOpen(true)}
                  onClose={() => setOpen(false)}
                  open={open}
                  label="Interval Type"
                  inputProps={{
                    style: { fontSize: "0.875rem" },
                  }}
                >
                  <MenuItem value="day">Day</MenuItem>
                  <MenuItem value="week">Week</MenuItem>
                  <MenuItem value="month">Month</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                type="number"
                label="Interval Value"
                value={editingItem?.interval_value || ""}
                onChange={(e) => setEditingItem({ ...editingItem, interval_value: e.target.value })}
                disabled={!editingItem?.interval_type}
                sx={{ 
                  '& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' } 
                }}
                InputLabelProps={{
                  shrink: true,
                  style: { fontSize: "0.875rem" },
                }}
                InputProps={{
                  style: { fontSize: "0.875rem" }, width: '100%'
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditDialogOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleUpdateItem} color="primary">
            Update
          </Button>
        </DialogActions>
      </Dialog>
      {/* Breakdowns Dialog */}
      <Dialog
        open={breakdownsDialogOpen}
        onClose={() => {
          setBreakdownsDialogOpen(false);
          setEditingBreakdown(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {currentItem?.item} Breakdowns
          <IconButton
            onClick={() => setBreakdownsDialogOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {currentItem?.breakdowns?.length > 0 ? (
            <List>
              {currentItem.breakdowns.map((breakdown) => (
                <ListItem key={breakdown.breakdown_id} alignItems="flex-start" disableGutters>
                  {editingBreakdown === breakdown.breakdown_id ? (
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Breakdown Description"
                          multiline
                          rows={3}
                          value={newBreakdownDescription}
                          onChange={(e) => setNewBreakdownDescription(e.target.value)}
                          sx={{ mb: 2,'& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' }  }}
                          InputLabelProps={{ shrink: true, style: { fontSize: "0.875rem" } }}
                          InputProps={{ style: { fontSize: "0.875rem" }, width: '100%' }}
                        />

                        <TextField
                          fullWidth
                          label="Breakdown Date"
                          type="date"
                          InputLabelProps={{ shrink: true, style: { fontSize: "0.875rem" } }}
                          value={newBreakdownDate}
                          onChange={(e) => setNewBreakdownDate(e.target.value)}
                          inputProps={{
                            max: new Date().toISOString().split("T")[0],
                            style: { fontSize: "0.875rem" },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1}>
                        <IconButton
                          onClick={() => {
                            handleEditBreakdown(
                              currentItem.id,
                              breakdown.breakdown_id,
                              editedBreakdownDescription,
                              editedBreakdownDate
                            );
                            setEditingBreakdown(null);
                          }}
                          color="primary"
                        >
                          <Icon>check</Icon>
                        </IconButton>
                        <IconButton onClick={() => setEditingBreakdown(null)} color="secondary">
                          <Icon>close</Icon>
                        </IconButton>
                      </Grid>
                    </Grid>
                  ) : (
                    <>
                      <ListItemText
                        primary={breakdown.description}
                        primaryTypographyProps={{ style: { fontSize: "0.875rem" } }}
                        secondary={
                          breakdown.breakdown_date
                            ? `Date: ${new Date(breakdown.breakdown_date).toLocaleDateString()}`
                            : "No date specified"
                        }
                        secondaryTypographyProps={{ style: { fontSize: "0.75rem" } }}
                      />
                      <IconButton
                        edge="end"
                        onClick={() => {
                          setEditingBreakdown(breakdown.breakdown_id);
                          setEditedBreakdownDescription(breakdown.description);
                          setEditedBreakdownDate(
                            breakdown.breakdown_date
                              ? new Date(breakdown.breakdown_date).toISOString().split("T")[0]
                              : ""
                          );
                        }}
                        color="primary"
                      >
                        <Icon>edit</Icon>
                      </IconButton>
                      <IconButton
                        edge="end"
                        onClick={() => handleDeleteBreakdown(breakdown.breakdown_id)}
                        color="error"
                      >
                        <Icon>delete</Icon>
                      </IconButton>
                    </>
                  )}
                </ListItem>
              ))}
            </List>
          ) : (
            <VuiBox textAlign="center" py={4}>
              <VuiTypography variant="body2" color="text">
                No breakdowns recorded for this task.
              </VuiTypography>
            </VuiBox>
          )}

          <VuiBox mt={3}>
            <VuiTypography variant="h6" color="white" mb={2}>
              Add New Breakdown
            </VuiTypography>
            <TextField
              fullWidth
              label="Breakdown Description"
              multiline
              rows={3}
              value={newBreakdownDescription}
              onChange={(e) => setNewBreakdownDescription(e.target.value)}
              sx={{ mb: 2,'& .MuiOutlinedInput-root': { width: '100%' }, 
                  '& .MuiInputBase-input': { width: '100% !important' }  }}
              InputLabelProps={{
                shrink: true,
                style: { fontSize: "0.875rem" },
              }}
              InputProps={{
                style: { fontSize: "0.875rem" }, width: '100%'
              }}
            />
            <TextField
              fullWidth
              label="Breakdown Date"
              type="date"
              InputLabelProps={{ shrink: true, style: { fontSize: "0.875rem" } }}
              value={newBreakdownDate}
              onChange={(e) => setNewBreakdownDate(e.target.value)}
              inputProps={{
                max: new Date().toISOString().split("T")[0],
                style: { fontSize: "0.875rem" },
              }}
            />
            <VuiButton
              variant="contained"
              color="primary"
              onClick={handleAddBreakdown}
              fullWidth
              sx={{ mt: 2 }}
              disabled={!newBreakdownDescription}
            >
              <Icon>add</Icon>&nbsp;Add Breakdown
            </VuiButton>
          </VuiBox>
        </DialogContent>
      </Dialog>
      {/* Stock Items Dialog */}
      <Dialog open={stockDialogOpen} onClose={() => setStockDialogOpen(false)}>
        <DialogTitle>Select Stock Item</DialogTitle>
        <DialogContent>
          <List>
            {stockItems.map((item) => (
              <ListItem
                button
                key={item.id}
                onClick={() => {
                  setSelectedStockItem(item);
                  setStockDialogOpen(false);
                  // Update the newPart state when a stock item is selected
                  setNewPart({
                    part_name: item.component || "",
                    manufacturer: item.manufacturer || "",
                    part_number: item.part_number || "",
                    quantity: 1, // Default to 1, can be changed
                    cost: item.cost || 0.0,
                  });
                }}
              >
                <ListItemText
                primaryTypographyProps={{ fontSize: "0.875rem" }}
                        secondaryTypographyProps={{ fontSize: "0.75rem" }}
                  primary={`${item.component} (${item.manufacturer} - ${item.part_number})`}
                  secondary={`Qty: ${item.quantity} - Cost: £${item.cost}`}
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setStockDialogOpen(false)} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <Footer />
    </DashboardLayout>
  );
}

export default MaintenanceTracker;
